// src/App.js
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./pages/Navbar";
import WelcomePage from "./pages/WelcomePage";
import Nations from "./pages/Nations";
import Alliances from "./pages/Alliances";
import Commanders from "./pages/Commanders";
import Users from "./pages/Users";
import VoteScreen from "./pages/VoteScreen";
import Map from "./pages/Map";
import ComparisonPage from "./pages/ComparisonPage";
import ErrorPopup from "./components/ErrorPopup";
import { ErrorProvider } from "./context/ErrorContext";
import { AuthProvider } from "./context/AuthContext";

import "@fortawesome/fontawesome-free/css/all.min.css";
import AllianceManagement from "./pages/AllianceManagement";
import PlayerManagement from "./pages/PlayerManagement";
// Import the new Merger Dashboard page
import MergerDashboard from "./pages/MergerDashboard";
import Events from "./pages/Events";
import InfiniteZombieShare from "./pages/InfiniteZombieShare";
import Admin from "./pages/Admin";
import BattleSimulation from "./pages/BattleSimulation";
import BattleSimulationCommanderProfiles from "./pages/BattleSimulationCommanderProfiles";
import SuperUserRoute from "./components/SuperUserRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import MyCommander from "./pages/MyCommander";
import Packs from "./pages/Packs";
import Voting from "./pages/Voting";
import SpendingEvents from "./pages/SpendingEvents";
import MessageCrafter from "./pages/MessageCrafter";
import Market from "./pages/Market";

const App = () => {
  return (
    <ErrorProvider>
      <AuthProvider>
        <Router>
          <Navbar />
          <div className="app-content">
            <Routes>
              <Route path="/" element={<WelcomePage />} />
              <Route path="/vote/:id/cast" element={<VoteScreen />} />
              <Route path="/home" element={<WelcomePage />} />
              <Route path="/nations" element={<Nations />} />
              <Route path="/alliances" element={<Alliances />} />
              <Route path="/commanders" element={<Commanders />} />
              <Route path="/commanders/history" element={<Commanders />} />
              <Route
                path="/commanders/review-ingestion"
                element={<Commanders />}
              />
              <Route
                path="/commanders/orphans"
                element={<Commanders />}
              />
              <Route path="/users" element={<Users />} />
              <Route
                path="/alliance-management"
                element={<AllianceManagement />}
              />
              <Route
                path="/player-management"
                element={<PlayerManagement />}
              />
              <Route path="/map" element={<Map />} />
              <Route path="/comparison-page" element={<ComparisonPage />} />
              <Route path="/merger-dashboard" element={<MergerDashboard />} />
              <Route path="/admin" element={<Admin />} />
              <Route
                path="/admin/market"
                element={(
                  <SuperUserRoute>
                    <Market />
                  </SuperUserRoute>
                )}
              />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:eventId" element={<Events />} />
              <Route
                path="/packs"
                element={(
                  <AuthenticatedRoute>
                    <Packs />
                  </AuthenticatedRoute>
                )}
              />
              <Route
                path="/tools/packs"
                element={(
                  <AuthenticatedRoute>
                    <Packs />
                  </AuthenticatedRoute>
                )}
              />
              <Route
                path="/tools/spending-events"
                element={(
                  <AuthenticatedRoute>
                    <SpendingEvents />
                  </AuthenticatedRoute>
                )}
              />
              <Route
                path="/tools/message-crafter"
                element={(
                  <AuthenticatedRoute>
                    <MessageCrafter />
                  </AuthenticatedRoute>
                )}
              />
              <Route
                path="/tools/voting"
                element={<Voting />}
              />
              <Route
                path="/my-commander"
                element={(
                  <AuthenticatedRoute>
                    <MyCommander />
                  </AuthenticatedRoute>
                )}
              />
              <Route
                path="/battle-simulation"
                element={(
                  <SuperUserRoute>
                    <BattleSimulation />
                  </SuperUserRoute>
                )}
              />
              <Route
                path="/battle-simulation/commander-profiles"
                element={(
                  <SuperUserRoute>
                    <BattleSimulationCommanderProfiles />
                  </SuperUserRoute>
                )}
              />
              <Route
                path="/events/share/:token"
                element={<InfiniteZombieShare />}
              />
            </Routes>
          </div>
          <ErrorPopup />
        </Router>
      </AuthProvider>
    </ErrorProvider>
  );
};

export default App;
